import { render, staticRenderFns } from "./RecoverPage.vue?vue&type=template&id=532366bd"
import script from "./RecoverPage.vue?vue&type=script&lang=js"
export * from "./RecoverPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports